<div class="dwnld-main">
    <div class="col-lg-12 row">
        <div class="col-lg-12 ml-2 data-sect">
            <div class="col-lg-12">
                <h3>File List</h3>
            </div>
            <hr>
            <table
                class="table"
                [svData]="investorProcessPDFsData"
                #sv="svDataTable"
                [svRowsOnPage]="pageSize"
                *ngIf="investorProcessPDFsData && investorProcessPDFsData.length > 0"
            >
                <thead>
                    <tr>
                        <th>Title</th>
                        <th class="text-center">View</th>
                        <th class="text-center">Delete</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of sv.data">
                        <td>{{ item.title }}</td>
                        <td class="text-center">
                            <img
                                src="assets/icons/icon_view.png"
                                class="cursor-pointer"
                                (click)="viewFile(item.url)"
                            >
                        </td>

                        <td class="text-center">
                            <img
                                src="assets/icons/delete_icon.png"
                                class="cursor-pointer"
                                (click)="deleteData(item.id)"
                            >
                        </td>
                    </tr>
                </tbody>
                <tfoot *ngIf="investorProcessPDFsData?.length > pageSize">
                    <tr>
                        <td
                            colspan="5"
                            class="center-paginator"
                        >
                            <sv-bootstrap-paginator></sv-bootstrap-paginator>
                        </td>
                    </tr>
                </tfoot>
            </table>
            <div *ngIf="investorProcessPDFsData?.length <= 0">No Data found</div>
        </div>
    </div>
</div>
